<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Confirm Registration</h1>
                <p class="text-muted">Enter confirmation code from email</p>
                <hm-alert/>
                <b-form @submit.prevent="onSubmit">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-key"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      name="code"
                      type="text"
                      class="form-control"
                      placeholder="Confirmation Code"
                      v-model="code"
                      v-validate="'required'"
                      :disabled="!ready"
                      :class="{ 'is-invalid': errors.has('code') && submitted }"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="link" class="px-0" :disabled="!ready" @click="onResendCode">Resend code</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button type="submit" variant="primary" class="px-4" :disabled="!ready">
                        <i class="fa fa-refresh fa-spin" v-if="!ready"></i>
                        Confirm
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
              <b-card-footer class="p-4">
                <hm-footer-logo/>
              </b-card-footer>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { authService } from '@/services';

export default {
  name: 'Confirm',
  props: ['email', 'codeParam'],
  data() {
    return {
      code: '',
      ready: true,
      submitted: false
    };
  },
  methods: {
    ...mapActions({
      alertClear: 'alert/clear',
      alertSuccess: 'alert/success',
      alertError: 'alert/error',
      alertException: 'alert/exception'
    }),
    onSubmit() {
      this.ready = false;
      this.submitted = true;
      this.alertClear();

      this.$validator.validate()
        .then(valid => {
          if (valid) {
            return authService.confirm(this.email, this.code)
              .then(resp => {
                this.$gtag.event('sign_up_confirm', { 'event_category': 'engagement' });
                this.$router.push({ name: 'Login', params: { email: this.email, msg: 'Email address verified!' } });
              })
              .catch(err => {
                this.alertException({ err, message: 'Failed to register user.' });
              });
          } else {
            this.alertError('Please enter the code sent to ' + this.email + ' and submit again.');
          }
        })
        .finally(() => {
          this.ready = true;
        });
    },
    onResendCode() {
      this.ready = false;
      this.submitted = false;
      this.alertClear();

      return authService.resend(this.email)
        .then(resp => {
          this.alertSuccess('Code has been resent!');
        })
        .catch(err => {
          this.alertException({ err, message: 'Error sending code, please try again.' });
        })
        .finally(() => {
          this.ready = true;
        });
    }
  },
  created() {
    // check for code parameter and auto-submit
    if (this.codeParam && this.codeParam.length > 0) {
      this.code = this.codeParam;
      this.onSubmit();
    }
  },
  watch: { // you have to use function syntax here, as warned in the docs
    '$route.params.codeParam': function (newVal, oldVal) {
      // check for code parameter and auto-submit
      this.code = newVal;
      if (this.code && this.code.length > 0) {
        this.onSubmit();
      }
    }
  }
}
</script>